import {
  FormEventHandler,
  useEffect
} from 'react'
import GuestLayout from '@/Layouts/GuestLayout'
import Checkbox from '@/Components/Checkbox'
import InputError from '@/Components/InputError'
import InputLabel from '@/Components/InputLabel'
import PrimaryButton from '@/Components/PrimaryButton'
import TextInput from '@/Components/TextInput'
import {
  Head,
  Link,
  useForm
} from '@inertiajs/react'

export default function Register() {
  const {data, setData, post, processing, errors, reset} = useForm({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    terms: false,
  })

  useEffect(() => {
    return () => {
      reset('password', 'password_confirmation')
    }
  }, [])

  const submit: FormEventHandler = (e) => {
    e.preventDefault()

    post(route('register'))
  }

  return (
    <GuestLayout>
      <Head title="Register"/>

      <form onSubmit={submit}>
        <div>
          <InputLabel htmlFor="name" value="Név"/>

          <TextInput
            id="name"
            name="name"
            value={data.name}
            className="mt-1 block w-full"
            autoComplete="name"
            isFocused={true}
            onChange={(e) => setData('name', e.target.value)}
            required
          />

          <InputError message={errors.name} className="mt-2"/>
        </div>

        <div className="mt-4">
          <InputLabel htmlFor="email" value="Email"/>

          <TextInput
            id="email"
            type="email"
            name="email"
            value={data.email}
            className="mt-1 block w-full"
            autoComplete="username"
            onChange={(e) => setData('email', e.target.value)}
            required
          />

          <InputError message={errors.email} className="mt-2"/>
        </div>

        <div className="mt-4">
          <InputLabel htmlFor="password" value="Jelszó"/>

          <TextInput
            id="password"
            type="password"
            name="password"
            value={data.password}
            className="mt-1 block w-full"
            autoComplete="new-password"
            onChange={(e) => setData('password', e.target.value)}
            required
          />

          <InputError message={errors.password} className="mt-2"/>
        </div>

        <div className="mt-4">
          <InputLabel htmlFor="password_confirmation" value="Jelszó megerősítése"/>

          <TextInput
            id="password_confirmation"
            type="password"
            name="password_confirmation"
            value={data.password_confirmation}
            className="mt-1 block w-full"
            autoComplete="new-password"
            onChange={(e) => setData('password_confirmation', e.target.value)}
            required
          />

          <InputError message={errors.password_confirmation} className="mt-2"/>
        </div>

        <div className="mt-4">
          <label className="flex items-start gap-2 text-sm text-gray-600">
            <Checkbox
              name="terms"
              checked={data.terms}
              onChange={(e) => setData('terms', e.target.checked)}
              className="mt-px"
              required
            />

            <span>
              Elolvastam és elfogadom az{' '}
              <a
                href="https://profilii.hu/docs/adatkezelesi_tajekoztato_2026-07-01-tol.pdf"
                target={"_blank"}
                className="underline rounded-md hover:text-gray-900 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-brand-700"
              >
                Adatkezelési tájékoztatót
              </a>
              . <span className="text-red-500">*</span>
            </span>
          </label>

          <InputError message={errors.terms} className="mt-2"/>
        </div>

        <div className="flex items-center justify-between mt-4">
          <Link
            href={route('login')}
            className="underline text-sm text-gray-600 hover:text-gray-900 rounded-md focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-brand-700"
          >
            Bejelentkezés
          </Link>

          <PrimaryButton className="ml-4" disabled={processing}>
            Regisztráció
          </PrimaryButton>
        </div>
      </form>
    </GuestLayout>
  )
}
